import React from "react";
import PortableText from "./portableText";
import CTALink from "./CTALink";

const CTA = ({ label, title, body, ctas }) => (
  <section className="container mx-auto text-center py-6 mb-12">
    <h2 className="w-full my-2 text-5xl font-bold leading-tight text-center">{title}</h2>
    <div className="w-full mb-4">
      <div className="h-1 mx-auto bg-white w-1/6 opacity-25 my-0 py-0 rounded-t"></div>
    </div>

    <div className="my-4 text-3xl leading-tight">
      <PortableText blocks={body} />
    </div>

    <div className="flex flex-wrap flex-col sm:flex-row items-center">
      {(ctas || []).map((c, i) => (
        <div
          className="max-w-xs flex-1 text-gray-700 text-center py-2 my-2 justify-center"
          key={`cta_${i}`}
        >
          <CTALink
            {...c}
            buttonActionClass="block mx-auto sm:ml-4 hover:underline bg-white text-gray-800 font-bold rounded-full py-4 px-8 shadow-lg"
          />
        </div>
      ))}
    </div>
  </section>
);

export default CTA;
